import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Sparkles } from "lucide-react";

export default function ComingSoon({ title }) {
  return (
    <Card className="border-[#d4af37]">
      <CardHeader>
        <CardTitle className="text-2xl">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-center justify-center py-16 space-y-4">
          <Sparkles className="w-16 h-16 text-[#d4af37]" />
          <h3 className="text-xl font-semibold text-neutral-800">Coming Soon</h3>
          <p className="text-neutral-600 text-center max-w-md">
            We're working hard to bring you this feature. Stay tuned for updates!
          </p>
        </div>
      </CardContent>
    </Card>
  );
}